import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminAnnualComplianceService } from "../../../admin-annual-compliance/service/admin-annual-compliance.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CountryService } from "app/services/country.service";
import { DomSanitizer } from "@angular/platform-browser";
import { AnnualComplianceService } from "app/annual-compliance/service/annual-compliance.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { PermitTypeDocumentService } from "app/services/permit-type-document.service";
import { environment } from "environments/environment";

@Component({
  selector: 'app-viewannualcompliance',
  templateUrl: './viewannualcompliance.component.html',
  styleUrls: ['./viewannualcompliance.component.scss']
})
export class ViewannualcomplianceComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;
  
  isLoading: boolean = false;
  isLoadingFile: boolean = false;
  img: any;
  pdfSrc: any;
  details_Id: any;
  complainceDetailsData: any;
  permitId: any;
  permitDetails: any;
  data: any;
  application_Id;
  documentData: any = [];
  documentsFileData: any;
  countries: any = [];
  countryName: any;
  isDuplicate: boolean;
  isLoadingImg: boolean = false;
  uploadedDocs: any;
  permitDocumentsLink: any = [];
  allDocs = [];
  aUser:string = "";

  constructor(private _router: Router,
    private _service: AdminAnnualComplianceService,
    private _route: ActivatedRoute,
    private confirmDialogService: ConfirmDialogService,
    private toastService: ToastNotificationService,
    private countryService: CountryService,
    private sanitizer: DomSanitizer,
    private documentService: DocumentsServiceService,
    private _permitDocs: PermitTypeDocumentService,
    private _annualCompliance: AnnualComplianceService) { }

  ngOnInit(): void {
    console.log(this.ctrlData.compliance_id)
    this.details_Id = this.ctrlData.compliance_id;
    this.getComplainceDetails();
this.aUser = environment.authWebApi.userData.User.Username;
  }

  async getComplainceDetails() {
    this.isLoading = true;
    const response = await this._service
      .viewPermitDetails(this.details_Id)
      .toPromise();
    if (response != null) {
      this.complainceDetailsData = response;
      this.getCountries();
      this.getPermitRelatedDocsByID();
      this.permitId = this.complainceDetailsData.permit_id;
    }

    this.isLoading = false;
  }

  async getCountries() {
    try {
      this.isLoading = true;
      const result = await this.countryService.listAllCountries().toPromise();
      if (result) {
        this.countries = result;
        this.isLoading = false;
        this.countries.forEach((country) => {
          if (country.id == this.complainceDetailsData.country) {
            this.countryName = country.desc;
            return;
          }
        });
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

 

  async onReject() {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to reject  this application?",
      async () => {
        this.isLoading = true;
        const data = await this._service
          .onRejectStatus(this.complainceDetailsData.id ,   this.aUser)
          .toPromise();
        if (data == true) {
          this.toastService.success(
            "The annual compliance status change  successfully",
            "success"
          );
          this.isLoading = false;
          this._router.navigate([
            `/admin-annual-compliance/application/${this.details_Id}`,
          ]);
          // this.backToList();
        } else {
          this.isLoading = false;
          this.toastService.error(
            "Your request could not be processed succesfully.Please try again.",
            "error"
          );
        }
      },
      () => {
        return false;
      }
    );
  }

  onApproved() {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to approve this appilcation?",
      async () => {
        this.isLoading = true;
        const data = await this._service
          .onApprovedStatus(
            this.complainceDetailsData.id,
            this.complainceDetailsData.Is_duplicate,
            this.aUser
          )
          .toPromise();
        if (data == true) {
          this.toastService.success(
            "The annual compliance cerificate has been approved ",
            "success"
          );
          this.isLoading = false;
          this._router.navigate([
            `/admin-annual-compliance/application/${this.details_Id}`,
          ]);
          // this.backToList();
        } else {
          this.isLoading = false;
          this.toastService.error(
            "Your request could not be processed succesfully.Please try again.",
            "error"
          );
        }
      },
      () => {
        return false;
      }
    );
  }

  onHold() {
    this.confirmDialogService.confirmThis(
      "Are you sure you want to hold this application?",
      async () => {
        this.isLoading = true;
        const data = await this._service
          .onHoldStatus(this.complainceDetailsData.id ,  this.aUser)
          .toPromise();
        if (data == true) {
          this.toastService.success(
            "The annual compliance status change  successfully",
            "success"
          );
          this.isLoading = false;
          this._router.navigate([
            `/admin-annual-compliance/application/${this.details_Id}`,
          ]);
          // this.backToList();
        } else {
          this.isLoading = false;
          this.toastService.error(
            "Your request could not be processed succesfully.Please try again.",
            "error"
          );
        }
      },
      () => {
        return false;
      }
    );
  }

  onChangeStatus() {
    this._router.navigate([
      `/admin-annual-compliance/application/${this.details_Id}`,
    ]);
  }

  backToList() {
    this._router.navigate(["/admin-annual-compliance/list"]);
  }
  patchDocs() {
    let newArr = [];
    this.permitDocumentsLink.forEach((element) => {
      const document_type_id = element.document_type_id;
      const foundEl: Array<any> = this.uploadedDocs.filter(
        (item) => item.document_type_id == document_type_id
      );
      if (foundEl && foundEl.length) {
        foundEl.forEach((el) => {
          newArr.push({
            document_type_id: document_type_id,
            fileName: el.file_name,
            id: el.id,
            document_link: el.document_link,
            date_created: el.date_created,
          });
        });
      }
    });
    this.allDocs = newArr.reduce((groups, item) => {
      const group = groups[item.document_type_id.toString()] || [];
      group.push(item);
      groups[item.document_type_id] = group;
      return groups;
    }, {});
    console.log("documents", this.allDocs);
  }
  
  async getPermitDocumentsById(): Promise<void> {
    try {
      const res: any = await this.documentService.getPermitById(this.complainceDetailsData.application_id).toPromise();
      if (res) {
        this.uploadedDocs = res;
        this.patchDocs();
      }
    } catch (err) {
      console.error(err);
    }
    this.isLoading = false;
  }
  
  async getPermitRelatedDocsByID(): Promise<void> {
    this.isLoading = true;
    try {
      const res: any = await this._permitDocs.getLinkedAndUnlinkedDoctypes(this.complainceDetailsData.permit_type_id).toPromise();
      if (res && res.PermitLinked) {
        this.permitDocumentsLink = res.PermitLinked;
        await this.getPermitDocumentsById();
      }
    } catch (err) {
      console.error(err);
    }
    this.isLoading = false;
  }
  async getPermitData() {
    const response = await this._service
      .getPermitData(this.permitId)
      .toPromise();
    if (response) {
      this.permitDetails = response;
      this.data = this.permitDetails.permits[0];
    }
  }

  viewDoc(file: any) {
    console.log("Uploaded Docs", this.uploadedDocs);
    console.log("View Document", file);
    if (file != undefined) {
      this.isLoadingImg = true;
      this.pdfSrc = null;
      let id = file.shareId ?? file.document_link.substring(file.document_link.indexOf('#') + 1);
      console.log("Document Id", id);
      if (file.document_link.includes('.pdf')) {
        this.documentService.downloadpdf(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.pdfSrc = objectURL;
          this.isLoadingImg = false;
        });
      } else {
        this.documentService.download(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          this.isLoadingImg = false;
        });
      }
    }
  }
}
